import React                        from "react";
import { Form, Modal, Button }      from "react-bootstrap";
import CloseBtn                     from 'assets/icons/Close.svg';
import Select                       from 'react-select';

function MedicineDetailsModal({currentMedicine, currentMedicineDetails, setShowMedicineDetail, showMedicineDetail, medLabel, setCurrentMedicineDetails, updateMedicineDetails}) {
  const dosage_units = [
    {
      value: 'tablets',
      label: 'Tablets'
    },
    {
      value: 'capsules',
      label: 'Capsules'
    },
    {
      value: 'tablespoons',
      label: 'Tablespoons'
    },
    {
      value: 'teaspoons',
      label: 'Teaspoons'
    },
    {
      value: 'sprays',
      label: 'Sprays'
    },
    {
      value: 'buffs',
      label: 'Buffs'
    },
    {
      value: 'ml',
      label: 'ML'
    }
  ]

  const handleMedicineDetailsChange = (e) => {
    const _value = e.target.type === 'checkbox' ? e.target.checked : e.target.value
    setCurrentMedicineDetails((prevState) => {
      return {...prevState, [e.target.name]: _value};
    });
  }

  const handleDosageUnitChange = (e) => {
    setCurrentMedicineDetails((prevState) => {
      return {...prevState, consumption_unit: e.value};
    });
  }

  return (
    <Modal className="medicine-details-modal" size="lg" show={showMedicineDetail} onHide={() => {setShowMedicineDetail(false)}} backdrop="static" keyboard={false}>
      <Modal.Header>
        <Modal.Title className="w-100 text-center">Medicine Consumption</Modal.Title>
        <button type="button" className="close" onClick={() => {setShowMedicineDetail(false)}}>
            <img src={ CloseBtn } alt="modal-close" />
        </button>
      </Modal.Header>
      <Modal.Body>
        <p>Please note that all the following medications is prescribed correctly. You are not able to retrieve or make changes once you send it to the patient.</p>
        <p className="med-name">{`${currentMedicine?.med?.label}(${currentMedicine?.med?.dosage}), ${currentMedicine?.med?.dosage_form}`}</p>
        <div className="d-flex align-items-center flex-nowrap">
            <span>Take</span>
            <Form.Control className="mx-2" type="number" name="consumption_quantity" min="1" style={{width: '15%'}} value={currentMedicineDetails.consumption_quantity} onChange={(e) => {handleMedicineDetailsChange(e)}}/>
            <Select className="mx-2 dosage-unit-select" name="consumption_unit" options={dosage_units} placeholder="" onChange={(e) => handleDosageUnitChange(e)}/>
            <Form.Control className="mx-2" type="number" name="consumption_per_day" min="1" style={{width: '15%'}} value={currentMedicineDetails.consumption_per_day} onChange={(e) => {handleMedicineDetailsChange(e)}}/>
            <span>Times A Day</span>
            <Form.Control className="mx-2" type="number" name="consumption_days" min="1" style={{width: '15%'}} value={currentMedicineDetails.consumption_days} onChange={(e) => {handleMedicineDetailsChange(e)}}/>
            <span>Days</span>
        </div>
        <div className="d-flex py-5 flex-wraps">
            {
            Object.keys(medLabel).map((key, i) => {
                return (
                <Form.Check inline key={`prescription-med-${i}`} className="mr-7">
                    <Form.Check.Input 
                    id={`prescription-med-${i}`} 
                    name={key}
                    type="checkbox" 
                    onChange={(e) => {handleMedicineDetailsChange(e)}}
                    />
                    <Form.Check.Label htmlFor={`prescription-med-${i}`} >{medLabel[key]}</Form.Check.Label>
                </Form.Check>
                );
            })
            }
        </div>
        <div>
            <div className="pb-1">Remarks</div>
            <Form.Control as="textarea" name="remarks" placeholder="Please indicate what this drug is meant for (e.g. Fever, Cough, etc.) and any other additional instructions." value={currentMedicineDetails.remarks} onChange={(e) => {handleMedicineDetailsChange(e)}}/>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={updateMedicineDetails}>Add</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default MedicineDetailsModal;
